<script setup lang="ts">
  import { computed } from 'vue'
  import { DocumentTextIcon, CalculatorIcon } from '@heroicons/vue/24/outline'
  import '@tato30/vue-pdf/style.css'
  import TEMPORARYCaseBaseComponent from '@/components/app/cases/TEMPORARYCaseBaseComponent.vue'
  import { ROUTES } from '@/router/routes'
  import LawSpecificData from '@/components/app/cases/law_specific_data/LawSpecificData.vue'
  import { useCaseStore } from '@/store/app/case/detail/caseDetailStore'
  import type { CustomerCase as Case } from '@/types/generated/types.gen'
  import LawSpecificDataCalculator from '@/components/app/cases/law_specific_data/LawSpecificDataCalculator.vue'

  const caseStore = useCaseStore()
  const caseRecord = computed<Case | null>(() => caseStore.caseRecord)
</script>

<template>
  <div class="h-full w-full">
    <TEMPORARYCaseBaseComponent>
      <div
        v-if="caseRecord"
        class="mt-4 flex items-center justify-between"
      >
        <a
          :href="`${ROUTES.APP.CASES.CASE_DETAIL.DOCUMENT_GENERATION.replace(':uuid', caseRecord.uuid)}`"
          class="inline-flex items-center gap-x-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm
            font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500
            disabled:pointer-events-none disabled:opacity-50"
        >
          <DocumentTextIcon class="h-5 w-5" />
          Dokument generieren
          <span class="badge bg-purple">KI</span>
        </a>
        <LawSpecificDataCalculator />
      </div>

      <LawSpecificData />
    </TEMPORARYCaseBaseComponent>
  </div>
</template>
